const FONT_SIZE_MAP = {
  '1': '10px',
  '2': '13px',
  '3': '16px',
  '4': '18px',
  '5': '24px',
  '6': '32px',
  '7': '48px',
};

/**
 * Convert deprecated <font> tags (produced by document.execCommand)
 * to <span> with inline CSS, which html2canvas renders correctly.
 */
const normalizeFontTags = (html) => {
  return html
    .replace(/<font([^>]*)>/gi, (_, attrs) => {
      const styles = [];
      const sizeMatch = attrs.match(/size=["']?(\d+)["']?/i);
      const colorMatch = attrs.match(/color=["']?([^"'\s>]+)["']?/i);
      const faceMatch = attrs.match(/face=["']?([^"'>]+)["']?/i);
      if (sizeMatch) styles.push(`font-size: ${FONT_SIZE_MAP[sizeMatch[1]] || '16px'}`);
      if (colorMatch) styles.push(`color: ${colorMatch[1]}`);
      if (faceMatch) styles.push(`font-family: ${faceMatch[1]}`);
      return styles.length ? `<span style="${styles.join('; ')}">` : '<span>';
    })
    .replace(/<\/font>/gi, '</span>');
};

const hasHtmlTags = (str) => /<[a-z][\s\S]*>/i.test(str);

/**
 * Prepare text for safe HTML rendering:
 * - plain text: convert \n → <br>
 * - HTML: normalize deprecated <font> tags to <span> with CSS
 */
export const prepareHtml = (text) => {
  if (!text) return '';
  if (hasHtmlTags(text)) return normalizeFontTags(text);
  return text.replace(/\n/g, '<br>');
};

/**
 * Strip all HTML tags, returning plain text only.
 */
export const stripHtml = (html) => {
  if (!html) return '';
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};
